import { Modal, notification } from "antd";
import Title from "antd/es/typography/Title";
import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useCreateReportCategoriesMutation } from "shared/api";
import { handleRequestError } from "shared/helpers";
import { Colors } from "shared/themes";
import { FormInput } from "shared/ui";

interface AddReportCategoriesModalProps {
  isOpenNewReportModal: boolean;
  closeAddReportModal: () => void;
}

const AddReportCategoriesModal: FC<AddReportCategoriesModalProps> = ({
  closeAddReportModal,
  isOpenNewReportModal,
}) => {
  const { t } = useTranslation();
  const [createReportCategory] = useCreateReportCategoriesMutation();
  const [api, contextHolder] = notification.useNotification();

  const { values, resetForm, handleChange, handleBlur, errors, isValid } =
    useFormikContext<{
      id: number;
      name: string;
    }>();

  const closeModal = () => {
    closeAddReportModal();
    resetForm();
  };

  const handleCreateReportCategory = async () => {
    try {
      await createReportCategory({ name: values.name });

      api.success({
        message: t("reports.success-title"),
        description: t("Report category successfully created"),
      });
    } catch (error) {
      api.error({
        message: t("reports.error-title"),
        description: handleRequestError(error, t("reports.error")),
      });
    } finally {
      closeModal();
    }
  };

  return (
    <>
      {contextHolder}

      <Modal
        title="Add Report Category"
        open={isOpenNewReportModal}
        onCancel={closeModal}
        onOk={handleCreateReportCategory}
        okButtonProps={{
          disabled: !isValid,
          style: {
            background: `${Colors.blue.primary}`,
          },
        }}
      >
        <Title level={5} className="text-[14px]">
          Report Category
        </Title>
        <FormInput
          value={values.name}
          fieldName="name"
          placeholder="Enter report category"
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.name}
          isError={!!errors.name}
        />
      </Modal>
    </>
  );
};

export default AddReportCategoriesModal;
